<template>
<otif-ecm-table
    ref="table"
    :title="title"
    :rows="settings"
    :columns="columns"
    :actions="actions"
    :columnlabel="columnlabel"
    :paginated="false"
    :customOptions="customOptions"
    @save="save"
    :sortCallback="sort">
    <slot name="table-header" slot="table-header"/>
    <slot name="empty" slot="empty">
        No items available.
    </slot>
</otif-ecm-table>
</template>

<script>

const columns = [{
    name: 'prop_name',
    label: 'Property Name'
},{
    name: 'prop_value',
    label: 'Value'
}];


export default {
    props: ['rows', 'columns', 'customOptions', 'title', 'actions', 'columnlabel'],

    computed: {
        settings: {
            cache: false,
            get() {
                return this.rows;
            }
        }
    },

    methods: {
       sort(colNumber, dir) {
            this.$emit('sort', colNumber, dir);
        },

       save(element) {
            this.$emit('save', element);
        },
    }
}

</script>
